import React, { Key, useState } from "react"
import { Dropdown, Flex, MenuProps, message } from "antd"
import { campaignStates } from "../../../types/campaigns"
import sbCampaignApi from "../api/sbCampaign.api"
import { setStateType } from "../../../types/setStateType"
import { ICampaignResult } from "../types/sbCampaignApi.types"
import { campaignsTypeEnum } from "../../sponsoredProductsSKCAntd/types/types"
import { ApiUnmanage } from "../../../api-wrapper/campaign/ApiCampaignName"
import AddCampaignToProject from "../../../components/AddCampaignToProject"
import SbSelectAudienceModal from "./SbSelectAudienceModal"

interface ICampaignActions {
  selectedCampaignIds: Key[]
  setCampaignDataForTable: setStateType<ICampaignResult[] | null>
}

enum options {
  "APPLY_BEST_CPC" = "Apply Best CPC",
  "UNMANAGE" = "Unmanage",
  "MANAGE" = "Manage",
  "PAUSE" = "Pause",
  "ENABLE" = "Enable",
  "ADD_TO_PROJECT" = "Add to project",
  "SELECT_AUDIENCE" = "Select audience",
}

const CampaignActions: React.FC<ICampaignActions> = ({
  selectedCampaignIds,
  setCampaignDataForTable,
}) => {
  const [isAddCampaignToProjectOpen, setIsAddCampaignToProjectOpen] = useState<boolean>(false)
  const [isSelectAudienceOpen, setIsSelectAudienceOpen] = useState<boolean>(false)

  function HandleManageCampaign(isManage: boolean) {
    const data = {
      isManage: isManage,
      campaignIds: selectedCampaignIds,
      type: campaignsTypeEnum.SPONSORED_BRANDS,
    }

    ApiUnmanage(data)
      .then((status) => {
        if (status >= 200 && status < 300) {
          setCampaignDataForTable((prevCampaignData) => {
            return prevCampaignData
              ? prevCampaignData?.filter((campaignData) => {
                  return !selectedCampaignIds.includes(campaignData.campaignId)
                })
              : null
          })

          message.success("Change manage status success")
          return
        }

        message.error("Change manage status error")
      })

      .catch((err) => {
        message.error("Change manage status error")
      })
  }

  function changeStateCampaign(state: campaignStates) {
    const statesByCampaignId = selectedCampaignIds.map((campaignId) => {
      return {
        campaignId: String(campaignId),
        state: state,
      }
    })
    sbCampaignApi
      .updateCampaignsState({ stateByCampaignIds: statesByCampaignId })
      .then((res) => {
        if (res.status !== 200) {
          message.error("Failed to update campaign status")
          return
        }

        setCampaignDataForTable((prevCampaigns) => {
          return prevCampaigns
            ? prevCampaigns.map((campaign) => {
                if (selectedCampaignIds.includes(campaign.campaignId)) {
                  return {
                    ...campaign,
                    campaignStatus: state,
                  }
                }

                return campaign
              })
            : null
        })
      })
      .catch(() => {
        message.error("Failed to update campaign status")
      })
  }

  function addToProject() {
    setIsAddCampaignToProjectOpen(true)
  }

  function selectAudience() {
    setIsSelectAudienceOpen(true)
  }

  const handleMenuClick: MenuProps["onClick"] = (event) => {
    switch (event.key) {
      case options.UNMANAGE:
        HandleManageCampaign(false)
        break
      case options.MANAGE:
        HandleManageCampaign(true)
        break
      case options.PAUSE:
        changeStateCampaign(campaignStates.PAUSED)
        break
      case options.ENABLE:
        changeStateCampaign(campaignStates.ENABLED)
        break
      case options.ADD_TO_PROJECT:
        addToProject()
        break
      case options.SELECT_AUDIENCE:
        selectAudience()
        break
    }
  }

  const items: MenuProps["items"] = [
    {
      label: options.UNMANAGE,
      key: options.UNMANAGE,
    },
    {
      label: options.MANAGE,
      key: options.MANAGE,
    },
    {
      label: options.PAUSE,
      key: options.PAUSE,
    },
    {
      label: options.ENABLE,
      key: options.ENABLE,
    },
    {
      label: options.ADD_TO_PROJECT,
      key: options.ADD_TO_PROJECT,
    },
    {
      label: options.SELECT_AUDIENCE,
      key: options.SELECT_AUDIENCE,
    },
  ]

  const menuProps = {
    items,
    onClick: handleMenuClick,
  }

  return (
    <Flex>
      <AddCampaignToProject
        campaignIds={selectedCampaignIds.map((campaignId) => Number(campaignId))}
        isOpen={isAddCampaignToProjectOpen}
        setIsOpen={setIsAddCampaignToProjectOpen}
      />
      <SbSelectAudienceModal
        selectedCampaignIds={selectedCampaignIds}
        isOpen={isSelectAudienceOpen}
        setIsOpen={setIsSelectAudienceOpen}
      />
      <Dropdown.Button menu={menuProps}>Campaign Actions</Dropdown.Button>
    </Flex>
  )
}

export default CampaignActions
